import styled from 'styled-components';

import { COLORS, ACQ, ACQ_NARROW, GRADIENTS } from '../../../../theme/tokens';
import { Panel, Text } from '../../../../components';

// The stats sit on the exact Figma panel surface — an opaque #18181b under a
// 0.32 black overlay (≈ #101012, GRADIENTS.featureCard) — overriding Panel's
// translucent default so the container reads solid, not see-through, over the
// page.
export const StatsPanel = styled(Panel)`
  background: ${GRADIENTS.featureCard};
`;

// Five operational stats. Desktop (Figma "Ops" 952) is a 3-column grid that
// floats Support Cases into the top-right, pushing Sent Notifications +
// Activated Players to row 2; the DOM keeps the logical/mobile order, so `order`
// does that reshuffle. Below 980 it collapses to the 2-column mobile layout
// (Figma 355) in natural reading order.
export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  & > *:nth-child(3) {
    order: 4; /* Sent Notifications → row 2, col 1 */
  }
  & > *:nth-child(4) {
    order: 5; /* Activated Players → row 2, col 2 */
  }
  & > *:nth-child(5) {
    order: 3; /* Support Cases → row 1, col 3 */
  }

  ${ACQ_NARROW} {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 10px;

    & > *:nth-child(3),
    & > *:nth-child(4),
    & > *:nth-child(5) {
      order: 0;
    }
  }
`;

export const Stat = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  min-width: 0;
`;

export const StatBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const StatValue = styled(Text)`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  color: ${ACQ.orange};
  font-variant-numeric: tabular-nums;
`;

export const StatLabel = styled(Text)`
  font-size: 12px;
  line-height: 1;
  color: ${COLORS.featureName};
`;
